import * as z from 'zod';

export const contractingPartyQuerySchema = z.enum(['brand', 'partner']);

type ContractingPartyQuerySchema = z.infer<typeof contractingPartyQuerySchema>;
export type ContractingPartyMutationSchema = ContractingPartyQuerySchema;

export const contractingPartyFormSchema = z.object({
  name: z.string(),
  value: contractingPartyQuerySchema,
});

type ContractingPartyFormSchema = z.infer<typeof contractingPartyFormSchema>;

export const defaultContractingParty = null;

export const contractingPartyOptions: ContractingPartyFormSchema[] = [
  { name: 'Brand', value: 'brand' },
  { name: 'Partner', value: 'partner' },
];

export function strToContractingParty(
  contractingParty: ContractingPartyQuerySchema | null
): ContractingPartyFormSchema | null {
  return contractingPartyOptions.find((option) => option?.value === contractingParty) ?? null;
}

export function contractingPartyToStr(contractingParty: ContractingPartyFormSchema | null) {
  return contractingParty?.value ?? null;
}
